import dynamic from "next/dynamic";
import MondayIntegrationsConnectionsConfig from "./monday-integrations-connections-config";
import MondayIntegrationsConnectionsAdvancedConfig from "./monday-integrations-connections-advanced-config";
const MondayIntegrationsConnectionsComponent = dynamic(()=>import("./monday-integrations-connections-component"));
export default {
    MondayIntegrationsConnectionsComponent,
    MondayIntegrationsConnectionsConfig,
    MondayIntegrationsConnectionsAdvancedConfig
};
